import { render, staticRenderFns } from "./View_Section.vue?vue&type=template&id=9fcef814&scoped=true"
import script from "./View_Section.vue?vue&type=script&lang=js"
export * from "./View_Section.vue?vue&type=script&lang=js"
import style0 from "./View_Section.vue?vue&type=style&index=0&id=9fcef814&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcef814",
  null
  
)

export default component.exports